import { useEffectOnce } from 'hook/useEffectOnce'
import { useLatestCallback } from 'hook/useLatestCallback'
import { useMemo } from 'react'

let locks = 0
let unlock: Function | undefined

function lock() {
  const top = document.documentElement.scrollTop || document.body.scrollTop
  const left = document.documentElement.scrollLeft || document.body.scrollLeft

  // Сохраняем текущую ширину скроллбара, чтобы избежать сдвига контента
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth

  // Используем position: fixed для iOS/Safari
  document.body.style.position = 'fixed'
  document.body.style.top = `-${top}px`
  document.body.style.left = `-${left}px`
  document.body.style.right = '0'
  document.body.style.width = '100%'
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`
  }
  
  document.body.classList.add('body-scroll-lock')

  unlock = () => {
    document.body.classList.remove('body-scroll-lock')
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.width = ''
    document.body.style.paddingRight = ''
    
    document.documentElement.scrollTop = top
    document.documentElement.scrollLeft = left
    document.body.scrollTop = top
    document.body.scrollLeft = left
    unlock = undefined
  }
}

export const useBodyScrollLock = (active: boolean): void => {
  const state = useMemo(() => ({ used: false }), [])

  const start = useLatestCallback(() => {
    if (!state.used) {
      state.used = true
      ++locks
      if (locks === 1) lock()
    }
  })

  const end = useLatestCallback(() => {
    if (state.used) {
      state.used = false
      --locks
      if (locks === 0) {
        if (unlock) unlock()
        else console.error('no unlock')
      }
    }
  })

  useMemo(() => {
    if (active) start()
    else end()
  }, [start, end, active])

  useEffectOnce(() => {
    return () => end()
  })
}
